import { Injectable } from '@angular/core';
import { SchedulerAuthService } from '../../../common/scheduler/services/auth.service';

@Injectable({
  providedIn: 'root',
})
export class HosesSchedulerAuthService extends SchedulerAuthService {
  override allowMovement(): boolean {
    return this.lookForRolesNeeded([
      'Admin',
      'Chief',
      'HosesChief',
      'HosesSupervisor',
    ]);
  }

  validateTrimming(): boolean {
    return this.lookForRolesNeeded([
      'Chief',
      'HosesChief',
      'HosesLeader',
      'HosesTrimming',
      'HosesSupervisor',
      'Admin',
    ]);
  }

  validateSelectingMold(): boolean {
    return this.lookForRolesNeeded([
      'Admin',
      'Chief',
      'HosesOperator',
      'HosesChief',
      'HosesLeader',
      'HosesSupervisor',
    ]);
  }

  override machineMaintenance(): boolean {
    return this.lookForRolesNeeded([
      'Chief',
      'HosesChief',
      'Admin',
      'HosesLeader',
      'HosesSupervisor',
    ]);
  }

  override editMachineOperators(): boolean {
    return this.lookForRolesNeeded([
      'Chief',
      'HosesChief',
      'HosesLeader',
      'Admin',

      'HosesSupervisor',
    ]);
  }

  movementToOven(): boolean {
    return this.lookForRolesNeeded([
      'Chief',
      'HosesChief',
      'HosesTrimming',
      'HosesLeader',
      'Admin',
      'HosesSupervisor',
    ]);
  }

  movementToAutoclave(): boolean {
    return this.lookForRolesNeeded([
      'Chief',
      'HosesChief',
      'HosesTrimming',
      'HosesLeader',
      'Admin',
      'HosesSupervisor',
    ]);
  }

  movementOutOfOven(): boolean {
    return this.lookForRolesNeeded([
      'Chief',
      'HosesChief',
      'HosesLeader',
      'Admin',
      'HosesSupervisor',
    ]);
  }

  movementOutOfAutoclave(): boolean {
    return this.lookForRolesNeeded([
      'Chief',
      'HosesChief',
      'HosesLeader',
      'Admin',

      'HosesSupervisor',
    ]);
  }

  override runningItemOff(): boolean {
    return this.lookForRolesNeeded([
      'Chief',
      'HosesChief',
      'HosesLeader',
      'Admin',

      'HosesSupervisor',
    ]);
  }

  override startEndWorkOrder(): boolean {
    return this.lookForRolesNeeded([
      'Chief',
      'HosesChief',
      'HosesLeader',
      'Admin',

      'HosesOperator',
      'HosesSupervisor',
    ]);
  }

  allowMovementToActionList(): boolean {
    return this.lookForRolesNeeded([
      'Chief',
      'HosesChief',
      'HosesLeader',
      'Admin',

      'HosesSupervisor',
    ]);
  }

  override sendItemToWaitingList(): boolean {
    return this.lookForRolesNeeded([
      'Chief',
      'HosesChief',
      'HosesSupervisor',
      'Admin',
    ]);
  }

  runFinishedWorkOrders(): boolean {
    return this.lookForRolesNeeded([
      'Chief',
      'HosesChief',
      'HosesLeader',
      'Admin',

      'HosesSupervisor',
    ]);
  }
}
